/**
 *
 */

var Sliders = (function($) {
  function initSliders() {
    var newsSwiper = new Swiper(".news-section-slider", {
      slidesPerView: 4.5,
      spaceBetween: 24,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        0: {
          slidesPerView: 1.2
        },
        578: {
          slidesPerView: 1.2
        },
        768: {
          slidesPerView: 2.2
        },
        1024: {
          slidesPerView: 4.5
        }
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".swiper").length) {
      return;
    }
  }

  initSliders();

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Sliders.init);
